import { useState } from "react";
import { Link } from "react-router-dom";
import { getAnalyticsConsent, setAnalyticsConsent } from "@/lib/analytics";

/**
 * Strict opt-in analytics notice. Shown only until the visitor chooses.
 * Accept injects the GA4 script; Decline guarantees it never loads.
 * The choice can be changed anytime on the Privacy page.
 */
export default function ConsentBanner() {
    const [visible, setVisible] = useState(() => getAnalyticsConsent() === null);

    if (!visible) return null;

    const choose = (value) => {
        setAnalyticsConsent(value);
        setVisible(false);
    };

    return (
        <div
            data-testid="analytics-consent-banner"
            role="region"
            aria-label="Analytics consent"
            className="fixed bottom-0 inset-x-0 z-[90] border-t px-6 md:px-10 py-5"
            style={{
                background: "rgba(10,9,8,0.97)",
                borderColor: "var(--hh-border)",
                backdropFilter: "blur(12px)",
            }}
        >
            <div className="max-w-[1480px] mx-auto flex flex-col md:flex-row md:items-center gap-4 md:gap-8">
                <p className="text-sm leading-relaxed flex-1" style={{ color: "var(--hh-text-dim)" }}>
                    <span className="overline block mb-2" style={{ color: "var(--hh-gold)" }}>
                        Your privacy
                    </span>
                    We use Google Analytics to understand how visitors use this site. It loads only if
                    you accept — declining means no analytics cookies or tracking at all. Details in our{" "}
                    <Link
                        to="/privacy"
                        data-testid="analytics-consent-privacy-link"
                        className="underline underline-offset-4"
                        style={{ color: "var(--hh-gold)" }}
                    >
                        privacy policy
                    </Link>
                    .
                </p>
                <div className="flex gap-3 shrink-0">
                    <button
                        data-testid="analytics-consent-decline"
                        onClick={() => choose("denied")}
                        className="btn-ghost"
                    >
                        Decline
                    </button>
                    <button
                        data-testid="analytics-consent-accept"
                        onClick={() => choose("granted")}
                        className="btn-gold"
                    >
                        Accept
                    </button>
                </div>
            </div>
        </div>
    );
}
